import { lazy, Suspense } from 'react'
const NutritionPage = lazy(async () => {
  const module = await import('@/features/nutrition/NutritionPage')
  return { default: module.NutritionPage }
})
export function NutritionRoute() { return <Suspense fallback={<p role="status">正在加载页面…</p>}><NutritionPage /></Suspense> }
